module.exports = __webpack_public_path__ + "static/media/7-R-Smart Plus.38bd51d7.jpg";